import React, { useEffect, useState } from 'react'
import { QcType } from '@pages/task/quality-check-reexamine-detail/constant'
import { Card, Button, message, Spin } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import CreateEditCompliance from './components/create-edit-compliance'
import CreateEditMoc from './components/create-edit-moc'
import CreateEditScenarioTag from './components/create-edit-scenario-tag'
import { getAIQualityCheckPlanDetail, saveAIQualityCheckPlan } from '@services/ai-quality-check'
import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'

const CreateSchemePage = ({ qcType, qcId, onBack, onSave }: { qcType: number, qcId: number | null, onBack: () => void, onSave: (id: number) => void }) => {
  const [qcPlanDetail, setQcPlanDetail] = useState<AIQualityCheckPlanDetailItem | null>(null)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    (async () => {
      if (qcId) {
        setLoading(true)
        const [res, err] = await getAIQualityCheckPlanDetail({ plan: [{ planId: qcId }] })
        if (err) {
          message.error(`获取方案详情失败:${err.message}`)
          setQcPlanDetail(null)
        } else {
          setQcPlanDetail(res.list.find(item => item.id === qcId) || null)
        }
        setLoading(false)
      }
    })()
  }, [qcId])
  const handleSave = async (data: AIQualityCheckPlanDetailItem) => {
    const [res, error] = await saveAIQualityCheckPlan(data)
    if (error) {
      message.error(`保存方案失败:${error.message}`)
    } else {
      message.success('保存方案成功')
      onSave(res.planId)
    }
  }
  const renderContent = (qcId: number | null) => {
    switch (qcType) {
      case QcType.compliance:
        return <CreateEditCompliance qcId={qcId} qcPlanDetail={qcPlanDetail} onSave={handleSave} />
      case QcType.moc:
        return <CreateEditMoc qcId={qcId} qcPlanDetail={qcPlanDetail} onSave={handleSave} />
      case QcType.scenarioTag:
        return <CreateEditScenarioTag qcId={qcId} qcPlanDetail={qcPlanDetail} onSave={handleSave} />
      default:
        return null
    }
  }
  return (
    <>
      <Card>
        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => {
          onBack()
        }}>
          <ArrowLeftOutlined />
          <span className="ml15" style={{ fontSize: 20 }}>返回</span>
          <span className="ml15">返回方案类型选择</span>
        </div>
      </Card>
      <Card className="scheme-container">
        <Spin spinning={loading}>
          {renderContent(qcId)}
        </Spin>
      </Card>
    </>
  )
}

export default CreateSchemePage
